import React from 'react'
import { FaBullhorn } from "react-icons/fa";



// images
import Usermangement from '../pages/images/usermanagement.png'
import clintlist from '../pages/images/clientList.png'
import clinttreeview from '../pages/images/client-tree-view.png'
import sitebranding from '../pages/images/site-branding.png'
import systemcredit from '../pages/images/system-credit-history.png'
import domainlink from '../pages/images/domainLink.png'
import Spamkeyword from '../pages/images/spam-keyword.png'
import SystemReport from '../pages/images/systemReport.png'
import deliverymis from '../pages/images/delivery-mis.png'
import TTS from '../pages/images/tts.png'
import bulkUpload from '../pages/images/bulkUpload.png'
import Apinumbers from '../pages/images/api-numbers.png'
import { Link } from 'react-router-dom';


const Administator = [
    {
        title: "UserManagement",
        description: "Easily manage users and permissions here.",
        slug: "/Admin/UserManagement/Index",
        image: Usermangement
    },
    {
        title: "Client List",
        description: "View your complete client list.",
        slug: "/Admin/ClientLists/Index",
        image: clintlist
    },
    {
        title: "Client Tree View",
        description: "Visualize your client hierarchy easily here.",
        slug: "/Admin/ClientTreeList/Index",
        image: clinttreeview
    },
    {
        title: "Site Branding",
        description: "White-Label Solution.",
        slug: "/Admin/SiteBranding/Index",
        image: sitebranding
    },
    {
        title: "System Credit History",
        description: "Monitor credit transactions within system history.",
        slug: "/Admin/SystemCreditHistory/Index",
        image: systemcredit
    },
    {
        title: "Domain SmartLink",
        description: "Manage domains within the system.",
        slug: "/Admin/DomainSmartLink/Index",
        image: domainlink
    }
];
const ReportingTools = [
    {
        title: "Archive Report",
        description: "Archive reports for future reference easily.",
        slug: "/Admin/ArchiveReportCommon/Index",
        image: Spamkeyword
    },
    {
        title: "System Traffic",
        description: "Monitor your system traffic in real-time.",
        slug: "/Admin/SystemTraffic/Index",
        image: SystemReport
    },
    {
        title: "Date Wise Statistics",
        description: "Track delivery performance with MIS insights.",
        slug: "/Admin/DateWiseStatistics/Index",
        image: deliverymis
    },
    {
        title: "DeliveryBase-User Refund",
        description: "Manage DeliveryBase user refunds effortlessly.",
        slug: "/Admin/DeliveryBaseUserReports/Index",
        image: TTS
    }
];
const SMSTools = [
    {
        title: "DLT Bulk Uploads",
        description: "Quick bulk uploads for DLT compliance.",
        slug: "/Admin/DLTBulkUploader/Index",
        image: bulkUpload
    }
];
const VoiceTools = [
    {
        title: "PRI Numbers",
        description: "Configure PRI numbers for seamless connectivity.",
        slug: "/Exchange/PRINumbers/Index",
        image: Apinumbers
    }
];

function Adminhome() {
    return (
        <>
            <div className='p-1 pt-[70px] dark:bg-[#121519]'>
                <div className='border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md dark:bg-[#121519] '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'>Administator   </span>
                        </div>
                    </div>
                    <div className='w-[100%] flex gap-4 flex-wrap  items-center pt-3 pb-5 '>
                        {Administator.map((item, index) => (
                            <div

                                className='text-white border-0 rounded-[20px] py-8 px-1 
                            w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
                            h-[160px] cursor-pointer text-center 
                            [transform-style:preserve-3d] transition-all duration-300 ease-in-out 
                            shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
                            hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
                            flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2 '>{item.description}</span>
                                </Link>
                            </div>
                        ))
                        }
                    </div>
                    <div>
                    </div>
                </div>
                <div className='border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md mt-4 dark:bg-[#121519] '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'>Reporting Tools   </span>
                        </div>
                    </div>
                    <div className='w-[100%] flex gap-4 flex-wrap  items-center pt-3 pb-5 '>
                        {ReportingTools.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
h-[160px] cursor-pointer text-center 
[transform-style:preserve-3d] transition-all duration-300 ease-in-out 
shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2'>{item.description}</span>
                                </Link>

                            </div>

                        ))
                        }

                    </div>
                    <div>

                    </div>
                </div>
                <div className='border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md mt-4 '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'>SMS Tools   </span>
                        </div>
                    </div>
                    <div className='w-[100%] flex justify-between flex-wrap gap-4 items-center pt-3 pb-5 '>
                        {SMSTools.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
h-[160px] cursor-pointer text-center 
[transform-style:preserve-3d] transition-all duration-300 ease-in-out 
shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2'>{item.description}</span>
                                </Link>

                            </div>

                        ))
                        }

                    </div>
                    <div>

                    </div>
                </div>
                <div className='border-[1px] border-[#d6d4d4] w-[100%] p-2 rounded-md mt-4 '>
                    <div className='  flex justify-between w-[100%] pl-2 pb-2 border-[#d6d4d4] border-b-[1px] '>
                        <div className='flex items-center gap-1 '>
                            <FaBullhorn className='text-[18px] dark:text-[#fff]' />
                            <span className='text-[14px] text-[#000] font-semibold dark:text-[#fff]'>Voice Tools</span>
                        </div>
                    </div>
                    <div className='w-[100%] flex justify-between flex-wrap gap-4 items-center pt-3 pb-5 '>
                        {VoiceTools.map((item, index) => (
                            <div className='text-white border-0 rounded-[20px] py-8 px-1 
w-full sm:w-[48%] md:w-[30%] lg:w-[22%] xl:w-[15%]
h-[160px] cursor-pointer text-center 
[transform-style:preserve-3d] transition-all duration-300 ease-in-out 
shadow-[0_12px_24px_rgba(0,0,0,0.2),0_6px_10px_rgba(0,0,0,0.1)] 
hover:shadow-[rgba(0,0,0,0.35)_0px_5px_15px] 
flex flex-col items-center  duration-400  hover:[transform:rotateX(12deg)_rotateY(-12deg)] group '>
                                <Link to={item.slug}>
                                    <div className='w-[100%] flex justify-center items-center'>
                                        <img className='w-[48px]' src={item.image} alt="" />
                                    </div>
                                    <h1 className='text-[#000] text-[14px] font-semibold transition-all duration-300 group-hover:-translate-y-1 group-hover:-translate-x-1 dark:text-[#fff]'>{item.title}</h1>
                                    <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff] leading-tight line-clamp-2 '>{item.description}</span>
                                </Link>
                            </div>

                        ))
                        }

                    </div>
                    <div>

                    </div>
                </div>
            </div >
        </>
    )
}

export default Adminhome
